<template>
  <div class="carousel-item__wrapper">
    <div v-if="fields && fields.image" class="cta-carousel__image-container">
      <sc-image
        v-if="fields && fields.image"
        :media="fields.image"
        class="cta-carousel__image"
        :class="{ padding: fields.padding.value === true }"
      />
    </div>
    <div
      v-if="fields && fields.center"
      class="cta-carousel__content"
      :class="[
        { center: fields.center.value === true },
        { padding: fields.padding.value === true }
      ]"
    >
      <sc-placeholder name="jss-cta-carousel-cta" :rendering="rendering" />
    </div>
  </div>
</template>

<script>
import { Image, Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-CTA-Carousel-Item',
  components: {
    ScPlaceholder: Placeholder,
    ScImage: Image
  },
  props: {
    rendering: {
      type: Object
    },
    fields: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
<style lang="scss" scoped>
.cta-carousel {
  &__link {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    // Hide Text
    text-indent: 100%;
    white-space: nowrap;
    overflow: hidden;
  }

  &__image-container {
    display: flex;
    align-items: center;
    height: 7.5rem;
  }

  &__image {
    width: calc(100% - 3rem);
    margin: 0 1.5rem;
    height: auto;
    max-height: 100%;

    &.padding {
      width: calc(100% - 3rem);
      margin: 0 1.5rem;

      @include tablet-up {
        width: calc(100% - 6rem);
        margin: 0 3rem;
      }
    }
  }

  &__content {
    display: inline-block;

    & & {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      padding-top: 1rem;
    }

    &.padding {
      padding: 1rem 1rem 0;

      @include tablet-up {
        padding: 1rem 2rem 0;
      }
    }
  }

  .center {
    text-align: center;
    align-content: center;
  }
}

.carousel-item__wrapper {
  display: grid;

  text-indent: initial;
  white-space: normal;
  overflow: initial;

  // Editor
  &.scEnabledChrome {
    margin-bottom: 5rem;

    .cta-carousel__image-container {
      height: auto;
    }

    .cta-carousel__content.center {
      text-align: left;
      align-content: flex-start;
    }

    &:deep() {
      img {
        max-height: 7.5rem;
        width: auto;
      }
    }
  }
}
</style>
